const joinClassNames = (...parts) => parts.filter(Boolean).join(' ')

export default function FilterBar({ left = null, right = null, summary = '', className = '' }) {
  return (
    <section className={joinClassNames('gg-filter-block', className)}>
      <div className="gg-filter-bar">
        <div className="gg-filter-bar__group">{left}</div>
        <div className="gg-filter-bar__group">{right}</div>
      </div>
      {summary ? <p className="gg-filter-block__summary">{summary}</p> : null}
    </section>
  )
}
